import { render, staticRenderFns } from "./msg-list.vue?vue&type=template&id=178c540a"
import script from "./msg-list.vue?vue&type=script&lang=ts"
export * from "./msg-list.vue?vue&type=script&lang=ts"
import style0 from "./msg-list.vue?vue&type=style&index=0&id=178c540a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports